(function ($) {
    class DetainmentModal {
        constructor() {
            this.modalOverlay = null;
            this.modalElement = null;
            this.closeButton = null;
            this.cancelButton = null;
            this.confirmButton = null;
            this.isOpen = false;

            this.styles = `
                .modal-overlay {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    z-index: 9999;
                }
            
                .modal-detainment {
                    position: relative;
                    background-color: #fff;
                    border-radius: 16px;
                    width: 980px;
                    height: 439px;
                }
            
                .modal-detainment .modal-content {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                    z-index: 99999;
                    position: relative;
                    width: 100%;
                }
                .modal-content > * {
                    flex: 1;
                }
                .modal-detainment .left-content {
                    overflow: hidden;
                    border-radius: 16px 0 0 16px;
                    height: 100%;
                    width: 460px;
                    flex: auto !important;
                }
                .modal-detainment .left-content img {
                    height: 100%;
                }
                .modal-detainment .right-content {
                    padding: 96px 40px 40px;
                    height: 100%;
                    max-width: 100%;
                }
                .modal-detainment .modal-close {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                    cursor: pointer;
                    z-index: 900;
                }
                .modal-detainment .header .desc{
                    color: #1D1D1D;
                    font-family: Montserrat;
                    font-size: 24px;
                    font-style: normal;
                    font-weight: 600;
                    line-height: 28px; 
                }
                .modal-detainment .img-wrapper img{
                    width: 80px;
                    height: 80px;
                }
               
                .text > * {
                    text-align: left;
                    color: #888;
                    font-family: Montserrat;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                    margin-bottom: 8px;
                }
                .text > *:last-child {
                    margin-bottom: 0;
                }
                .text a {
                    color: #0074FF;
                }
                .modal-detainment .po-btn-wrapper {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 16px;
                    margin: 56px 0 16px;
                }
                .modal-detainment .po-btn--cancel {
                    width: 234px;
                    height: 52px;
                    padding: 16px 24px;
                    border-radius: 28px;
                    background: #F8F9FC;
                    text-align: center;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                    color: #000000;
                }
                .modal-detainment .po-btn--confirm {
                    width: 197px;
                    height: 52px;
                    line-height: 52px;
                    border-radius: 40px;
                    background: #0074FF;
                    text-align: center;
                    color: #ffffff;
                    font-family: Montserrat;
                    font-size: 14px;
                    font-weight: 600;
                    cursor: pointer;
                }

                @media (max-width: 1024px) { 
                    .modal-detainment {
                        width: 343px;
                        height: 483px;
                        border-radius: 24px;
                        overflow: hidden;
                    }
                    .modal-detainment .modal-content {
                        overflow-y: scroll;
                        flex-direction: column;
                    }
                    .modal-detainment .left-content {
                        max-height: 200px;
                        width: 100%;
                        overflow: hidden;
                        border-radius: 24px 24px 0 0;
                    }
                    .modal-detainment .right-content {
                        padding: 24px 16px !important;
                    }
                    .modal-detainment .left-content img {
                        height: 200px !important;
                    }
                    .modal-detainment .img-wrapper img {
                        width: 80px;
                        height: 80px;
                    }
                    .modal-detainment .header .desc {
                        font-size: 17px;
                        line-height: 21px;
                    }
                    .modal-detainment .header .sec-desc {
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 18px;
                    }
                    .modal-detainment .po-btn-wrapper {
                        margin: 32px 0 8px;
                    }
                    .modal-close {
                        position: fixed;
                        right: 24px;
                    }
                    .modal-detainment .po-btn--cancel {
                        width: 170px;
                        border-radius: 64px;
                        padding: 12px 14px;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 16px;
                        height: auto;
                    }
                    .modal-detainment .po-btn--confirm {
                        width: 132px;
                        border-radius: 64px;
                        padding: 12px 16px;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 16px;
                        height: auto;
                    }
                    .modal-detainment .po-btn-wrapper {
                        gap: 0px;
                    }
                    .modal-detainment .po-btn--confirm {
                        line-height: normal;
                        margin-left: 8px;
                    }

                    .modal-detainment .text > div:last-child {
                        margin-bottom: 0;
                    }
                }
                `;
        }

        /**
         * Creates a modal element with the given content.
         *
         * @param {Object} content - The content of the modal element.
         * @param {string} content.desc - The description of the modal.
         * @param {string} content.price - The price of the modal.
         * @param {Array<string>} content.text - The text items of the modal.
         * @return {HTMLElement} The created modal element.
         */
        createModalElement(content = {}) {
            const { text, imgUrlList = [] } = content;
            const [pcImageUrl, mobileImageUrl] = imgUrlList;
            const styleElement = document.createElement('style');
            styleElement.textContent = this.styles;

            const modalOverlay = document.createElement('div');
            modalOverlay.classList.add('modal-overlay');
            modalOverlay.classList.add('care-modal-overlay');
            modalOverlay.innerHTML = `
                <div class="modal-detainment">
                    <div class="modal-content">
                        <span class="modal-close">
                            <img class="close_btn" src="https://cdn.shopify.com/s/files/1/0467/7985/9095/files/modal-close.png?v=1695288272" width="32" height="32">
                        </span>
                        <div class="left-content">
                            <picture class="lozad">
                                <source media="(max-width: 950px)" srcset="${mobileImageUrl}" />
                                <img src="${pcImageUrl}" alt="pc image"/>
                            </picture>
                        </div>
                        <div class="right-content">
                            <div class="header">
                                <div class="desc">
                                    Want to request a quote and pay with a Purchase Order?  
                                </div>

                                <div class="sec-desc mt-8">
                                    Makeblock supports school payment via Purchase Order*
                                </div>
                            </div>
                            
                            <div class="po-btn-wrapper">
                                <div class="po-btn--cancel continue_btn">No, Continue Shopping</div>
                                <div class="po-btn--confirm get_quote_btn">Yes, Get a Quote</div>
                            </div>
                            <div class="text">
                                ${text?.map((item) => `<div>${item}</div>`).join('')}
                                <div>*Gain Full insight of the <a href="https://www.makeblock.com/pages/pay-with-purchase-order" target="_blank">PO Process</a></div>
                            </div>
                        </div>
                    </div>
                </div>
                `;

            this.modalOverlay = modalOverlay;
            this.modalElement = modalOverlay.querySelector('.modal');
            this.closeButton = modalOverlay.querySelector('.modal-close');
            this.cancelButton = modalOverlay.querySelector('.po-btn--cancel');
            this.confirmButton = modalOverlay.querySelector('.po-btn--confirm');
            document.head.appendChild(styleElement);
            return modalOverlay;
        }

        open(content) {
            if (this.isOpen) {
                return;
            }
            const modalOverlay = this.createModalElement(content);
            document.body.appendChild(modalOverlay);
            this.isOpen = true;
            this.addEventListeners();
            if (theme.current.is_mobile) {
                this.stopScroll();
            }
        }

        close() {
            if (!this.isOpen) {
                return;
            }
            this.modalOverlay.remove();
            this.isOpen = false;
            this.removeEventListeners();
            this.handleSetModalStatus();
            theme.Cart.showPopup();
            if (theme.current.is_mobile) {
                this.recoverScroll();
            }
        }

        addEventListeners() {
            this.closeButton.addEventListener('click', this.close.bind(this));
            //this.modalOverlay.addEventListener('click', this.handleOverlayClick.bind(this));
            this.cancelButton.addEventListener('click', this.handleCancelButtonClick.bind(this));
            this.confirmButton.addEventListener('click', this.handleConfirmButtonClick.bind(this));
            document.addEventListener('keydown', this.handleKeyDown.bind(this));
        }

        removeEventListeners() {
            this.closeButton.removeEventListener('click', this.close.bind(this));
            //this.modalOverlay.removeEventListener('click', this.handleOverlayClick.bind(this));
            this.cancelButton.removeEventListener('click', this.handleCancelButtonClick.bind(this));
            this.confirmButton.removeEventListener('click', this.handleConfirmButtonClick.bind(this));
            document.removeEventListener('keydown', this.handleKeyDown.bind(this));
        }

        handleCancelButtonClick() {
            this.close();
            this.handleSetModalStatus();
            theme.Cart.showPopup();
        }

        handleConfirmButtonClick() {
            this.close();

            setTimeout(() => {
               window.location.href = '/cart?showQuotation=true&resource=PO_callback';
            }, 800);
        }
        handleOverlayClick(event) {
            if (event.target === this.modalOverlay) {
                this.close();
            }
        }

        handleKeyDown(event) {
            if (event.key === 'Escape') {
                this.close();
            }
        }

        handleSetModalStatus() {
            sessionStorage.setItem(`modal_status_${__MakeBlock_Utils.getCurrentVariant().id}`, 'closed');
        }

        checkModalStatus() {
            // 可以谈挽留弹窗
            // if (!getCurrentProductCareInfo()) {
            //     return false;
            // }
            const modalStatus = sessionStorage.getItem(`modal_status_${__MakeBlock_Utils.getCurrentVariant().id}`);
            return modalStatus === null || modalStatus !== 'closed';
        }
        // 展示弹窗时，阻止背景滚动
        stopScroll() {
            let top = document.body.scrollTop || document.documentElement.scrollTop;
            document.body.style.position = 'fixed';
            document.body.style.top = `${-1 * top}px`;
            // document.body.style.width = `100%`;
        }
        // 隐藏弹窗时，恢复背景的滚动
        recoverScroll() {
            let top = -parseInt(document.body.style.top);
            document.body.style.position = 'static';
            document.body.style.top = 0;
            window.scrollTo(0, top);
        }
    }

      function openDetainmentDialog() {
        const __content = {
            desc: `Want to request a quote and pay with a Purchase Order?`,
            text: [`*Please note: this payment option is available to schools in the US only.`],
            imgUrlList: ['https://cdn.shopify.com/s/files/1/0070/5901/3716/files/po-dialog-pc.png?v=1717385280', 'https://cdn.shopify.com/s/files/1/0467/7985/9095/files/po-dialog-mo.png?v=1717398868'],
        };

        if (window.detainmentModal.checkModalStatus()) {
            window.detainmentModal.open(__content);
        }
    }

    window.__po__detainmentModal_open = true;

    window.detainmentModal = new DetainmentModal();
    window.openDetainmentDialog = openDetainmentDialog;

})(jQueryTheme);